import { createTheme } from "@material-ui/core/styles";
import arrowDownIcon from "../assets/icons/arrowDownDark.svg";
import ConfigTheme from "../config/index";

const theme = createTheme({
  typography: {
    fontFamily: "Helvetica",
  },
  palette: {
    text: {
      primary: ConfigTheme.companyTextPrimaryColor,
      secondary: ConfigTheme.companyTextSecondaryColor,
    },
    primary: {
      main: ConfigTheme.companyPrimaryColor,
      light: "#fff",
    },
    secondary: {
      main: ConfigTheme.companySecondaryColor,
    },
    grey: {
      main: ConfigTheme.companyPrimaryGreyColor,
    },
    success: {
      main: ConfigTheme.companyMainSuccessColor,
      light: ConfigTheme.companyLightSuccessColor,
      dark: ConfigTheme.companyDarkSuccessColor,
      contrastText: ConfigTheme.companyContrastTextSuccessColor,
    },
    error: {
      main: ConfigTheme.companyMainErrorColor,
      light: ConfigTheme.companyLightErrorColor,
      dark: ConfigTheme.companyDarkErrorColor,
      contrastText: ConfigTheme.companyContrastTextErrorColor,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
        "&:hover": {
          boxShadow: "none",
        },
        textTransform: 'none',
        color: 'white',
      },
      label: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      contained: {
        background: ConfigTheme.companyContainedColorBtn,
        boxShadow: ConfigTheme.companyContainedBoxShadowBtn,
        //backgroundColor: "#fff",
        borderRadius: 12,
        padding: 8,
        color: "#fff !important",
        textDecoration: "none",
        transition: "all 0.2s ease-out",
        "&:hover": {
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: "#00D8D8 !important",
          color: "#fff !important",
        },
        "&:disabled": {
          background: "#B0B0B0",
          //opacity: 0.6,
          color: "#fff",
        },
      },
      outlined: {
        border: "2px solid",
        borderRadius: 12,
        fontWeight: "normal",
        textDecoration: "none",
        padding: 8,
      },
      sizeSmall: {
        width: 150,
        height: 40,
        padding: "3.6px 18px",
        fontSize: 14,
        border: "solid 1px #00D8D8",
      },
      sizeLarge: {
        padding: "16px 18px",
        fontSize: 17,
      },
      colorInherit: {
        color: "#2E2E2E",
        background: "#F1F1F1",
        border: "none",
        boxShadow: "0px 0px 5px 1px rgba(45, 64, 80, 0.15)",
      },
      outlinedPrimary: {
        background: ConfigTheme.companyContainedColorBtn,
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
      },
      startIcon: {
        marginLeft: 0,
        marginRight: 0,
      },
      iconSizeSmall: {
        marginTop:3,
        marginRight: 4
      }
    },
    MuiInput: {
      root: {
        backgroundColor: "#fff",
        borderRadius: 12,
        color: "#2D4050",
        border: "solid 1px #666666",
        "&:active": {
          border: "solid 1px #00D8D8",
        },
        "&$disabled": {
          opacity: 0.8,
        },
        "&:focus": {
          color: "#fff !important",
          border: "1.5px solid #00D8D8",
        },
      },
      input: {
        padding: "0px 2px",
        fontSize: 17,
        color: "#2D4050",
      },
      inputMarginDense: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiSelect: {
      root: {
        backgroundColor: "#EAEDF4",
        padding: 0,
        borderRadius: 12,
        fontSize: 17,
        color: "#2D4050",
      },
      icon: {
        backgroundImage: `url(${arrowDownIcon})`,
        color: "#B0B0B0",
        backgroundRepeat: "no-repeat",
        height: 25,
        width: 25,
        right: 10,
        top: "calc(50% - 10px)",
      },
      selectMenu: {
        padding: 9,
        borderRadius: 12,
        backgroundColor: "#fff",
      },
    },
    MuiTableContainer: {
      root: {
        padding: 10,
        display: "flex",
        overflow: "none",
        overflowX: "none",
      },
    },
    MuiTable: {
      stickyHeader: {
        backgroundColor: "#fff",
      },
    },
    MuiTableCell: {
      root: {
        color: "#FDFDFD",
        overflow: "none",
        overflowX: "none",
      },
      stickyHeader: {
        backgroundColor: "#fff",
        fontSize: 16,
        fontWeight: "bold",
        position: "inherit",
        color: "#2E2E2E"
      },
      sizeSmall: {
        padding: 10,
      },
    },
    MuiDialog: {
      container: {
        background: "rgba(0, 0, 0, 0.6)",
      },
      paper: {
        borderRadius: 20,
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.3)",
      },
      paperWidthSm: {
        width: "auto",
        overflowX: "hidden",
      },
    },
    MuiDialogTitle: {
      root: {
        color: "#2E2E2E",
        fontSize: 14,
        fontWeight: "400",
      },
    },
    MuiMenu: {
      paper: {
        //borderTop: "1.5px solid red",
        border: 'none', /* Grosor del borde */
        borderTop: '5px solid transparent', /* Habilitar el borde superior */
        borderImage: 'linear-gradient(to right, transparent 20%, #00D8D8 20%, #00D8D8 80%, transparent 80%) 1'
      },
      list: {
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
        borderTop: 0,
        padding: 12,
        display: "flex",
        flexDirection: "column",
        gridGap: 8,
      },
    },
    MuiMenuItem: {
      root: {
        borderRadius: 12,
        "&:hover": {
          color: "#00D8D8",
          backgroundColor: "#E6F6F7",
        },
      },
    },
    MuiSwitch: {
      root: {
        width: 73,
        height: 36,
        padding: 0.2,
      },
      switchBase: {
        padding: 4,
        paddingLeft: 7,
        "&$checked": {
          transform: "translateX(34px)",
          color: "#fff",
          "& + $track": {
            opacity: 1,
            border: "none",
          },
        },
      },
      thumb: {
        width: 28,
        height: 28,
        backgroundColor: "#fff",
        marginLeft: -1.5,
      },
      track: {
        borderRadius: 100,
        backgroundColor: "#C6CAD2",
        opacity: 1,
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 10,
      },
    },
    MuiInputLabel: {
      root: {
        "&$focused": {
          background: "#fff",
          padding: "2px 8px",
          borderRadius: 50,
          color: "#888888",
        },
      },
      filled: {
        top: 12,
      },
      shrink: {
        top: -2,
        background: "#fff",
        borderRadius: 50,
        color: "#888888",
      },
      outlined: {
        transform: "translate(14px, 14px) scale(1)",
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: "#fff",
        padding: "8px 20px",
        height: 45,
        borderRadius: 12,
        color: "#2D4050",
        border: "solid 1px #666666",
        "&::placeholder": {
          color: "#888888",
        },
        "&$focused": {
          border: "solid 1.5px #00D8D8",
          outlineWidth: 0,
          stroke: 0,
        },
        "&$disabled": {
          opacity: 0.8,
        },
      },
      notchedOutline: {
        border: "none",
      },
      input: {
        padding: "0px 2px",
        fontSize: 17,
        color: "#2D4050",
      },
      inputMarginDense: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiTypography: {
      h2: {
        fontSize: 28,
        fontWeight: "bold",
      },
      h5: {
        fontSize: 26,
        fontWeight: "bold",
      },
      h6: {
        fontSize: 20,
      },
      subtitle1: {
        fontSize: 18,
      },
    },
    MuiDivider: {
      root: {
        width: "100%",
        backgroundColor: "#8888",
      },
    },
    MuiCheckbox: {
      root: {
        "&$checked": {
          color: "#00D8D8 !important",
        },
      },
    },
  },
  shadows: [
    "none",
    "0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    //
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
    "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
  ],
  breakpoints: {
    values: {
      xl: 1440,
      lg: 1024,
      md: 960,
      sm: 768,
      xs: 320,
    },
  },
});

export default theme;
